/* Manu AI v23 (22/10/2026) — « Autre demande » et retouches rapides passent par la retouche fidèle (v15), sans redessiner.
 * - « Autre demande » : Manu demande ce qu'il faut changer sur la face affichée (avec les raccourcis de « Refaire »), la phrase part
 *   directement en retouche du logo actuel (base + edit), sans aller-retour de chat.
 * - « Plus minimaliste » et « Plus drôle » : retouche fidèle de chaque face dessinée par Manu (au lieu d'un nouveau dessin).
 * - Une demande libre faite dans le chat à l'étape résultat (retouche décidée par Manu) suit le même chemin.
 * Faces importées ou mode démo (sans serveur) : comportement d'origine. S'appuie sur v15 (applyEdit, redo-*) et v17 (editQueue). */
(function () {
  'use strict';

  var EDIT = {
    minimal: 'Make the design more minimalist: simpler composition, fewer details and fewer colours. Keep the main subject and the lettering.',
    funny: 'Make the design funnier and more playful, with a humorous twist. Keep the same subject, lettering and layout recognisable.'
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v23) return;
    inst._v23 = true;

    function manuSides() {
      var s = inst.s, f = s && s.faces || {};
      return ['front', 'back'].filter(function (k) { return f[k] && f[k].src && !f[k].own && !f[k].mock; });
    }
    function eligible() { var s = inst.s; return !!(inst.endpoint && s && s.path === 'story' && manuSides().length && inst.canDecline && inst.canDecline()); }

    // Retouche fidèle de une ou plusieurs faces (file d'attente de la v17 : chaque face passe par v15 avec sa demande)
    function fidelity(sides, text) {
      var s = inst.s;
      s.editQueue = s.editQueue || {};
      sides.forEach(function (k) { s.editQueue[k] = String(text).slice(0, 300); });
      s.pending = null; inst.quick.innerHTML = '';
      inst.lockThread(); inst.resultEl = null;
      inst.generateFaces(sides, true);
    }

    // Demande décidée par Manu dans le chat (étape résultat) : face citée, sinon toutes les faces dessinées
    var baseRetouch = inst.retouch;
    inst.retouch = function (text, place) {
      if (!eligible()) return baseRetouch.apply(this, arguments);
      var have = manuSides(), sides = (place === 'front' || place === 'back') ? have.filter(function (k) { return k === place; }) : have;
      if (!sides.length) return baseRetouch.apply(this, arguments);
      fidelity(sides, text);
    };

    // Puces rapides « Plus minimaliste » / « Plus drôle »
    var baseCmd = inst.command;
    inst.command = function (cmd, value, label) {
      if (cmd === 'tweak' && (value === 'minimal' || value === 'funny') && eligible()) {
        if (label) this.user(label);
        fidelity(manuSides(), EDIT[value]);
        return;
      }
      return baseCmd.apply(this, arguments);
    };

    // « Autre demande » (v18) : question + raccourcis, puis la phrase libre part en retouche fidèle de la face affichée
    var baseChips = inst.chips;
    inst.chips = function (opts) {
      var s = this.s;
      if (opts && opts.length === 1 && opts[0].cmd === 's18-back' && eligible()) {
        var side = s.edit && manuSides().indexOf(s.edit) !== -1 ? s.edit : manuSides()[0], t = inst.redoTx ? inst.redoTx() : null, self = this, back = opts[0];
        if (t && side) {
          s.pending = 'redo-edit'; s.redoSide = side;
          var name = (this.t.sides[side] || side).toLowerCase();
          this.bot(esc(t.ask.replace('{side}', name))).then(function () {
            baseChips.call(self, [
              { cmd: 'redo-hint', v: 'colors', l: t.colors }, { cmd: 'redo-hint', v: 'text', l: t.text }, { cmd: 'redo-hint', v: 'simple', l: t.simple }, back
            ]);
            if (self.replyField) self.replyField.focus({ preventScroll: true });
          });
          return;
        }
      }
      return baseChips.call(this, opts);
    };
  }

  function boot(n) {
    n = typeof n === 'number' ? n : 0;
    document.querySelectorAll('[data-ais]').forEach(function (root) {
      var i = root._ais;
      if (i && i._v15 && i._v17 && i._v18) enhance(root);
      else if (n < 40) setTimeout(function () { boot(n + 1); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { boot(0); }, 10); });
})();
